import {
  Skeleton,
  SkeletonBlock,
  SkeletonContent,
  SkeletonLine,
} from '@one-thd/sui-atomic-components';
import React, { JSX } from 'react';

/**
 * Returns either a row or a requested number of rows of skeleton content
 */
const DownloadSkeletonRow = (
  numberOfRows?: number,
): JSX.Element | JSX.Element[] => {
  if (numberOfRows) {
    return Array.from(
      { length: numberOfRows },
      (_unused: unknown, index: number) => (
        <SkeletonContent
          key={'download-skeleton-row-' + index}
          grow
          orientation="horizontal"
          disablePadding
          data-testid="skeleton-line"
        >
          <SkeletonContent initialSize="1/4" disablePadding>
            <SkeletonLine variant="heading" fullWidth />
          </SkeletonContent>
          <SkeletonContent initialSize="2/4" disablePadding>
            <SkeletonLine variant="heading" fullWidth />
          </SkeletonContent>
          <SkeletonContent initialSize="1/4" disablePadding>
            <SkeletonLine variant="heading" fullWidth />
          </SkeletonContent>
          <SkeletonContent initialSize="1/4" disablePadding>
            <SkeletonLine variant="heading" fullWidth />
          </SkeletonContent>
        </SkeletonContent>
      ),
    );
  }
  return (
    <SkeletonContent grow orientation="horizontal" disablePadding>
      <SkeletonContent initialSize="1/4" disablePadding>
        <SkeletonLine variant="heading" fullWidth />
      </SkeletonContent>
      <SkeletonContent initialSize="2/4" disablePadding>
        <SkeletonLine variant="heading" fullWidth />
      </SkeletonContent>
      <SkeletonContent initialSize="1/4" disablePadding>
        <SkeletonLine variant="heading" fullWidth />
      </SkeletonContent>
      <SkeletonContent initialSize="1/4" disablePadding>
        <SkeletonLine variant="heading" fullWidth />
      </SkeletonContent>
    </SkeletonContent>
  );
};

/**
 * Full Download Table Skeleton with Tabs Component
 * use for waiting for graphql data to load
 */
export const DownloadTableSkeleton = () => {
  return (
    <div data-testid="download-table-skeleton">
      <Skeleton
        grow
        SkeletonContentProps={{
          initialSize: 'full',
        }}
      >
        {DownloadSkeletonRow(10)}
      </Skeleton>
    </div>
  );
};

/**
 * Full Download Table Skeleton with Tabs Component
 * use for waiting for graphql data to load
 */
export const DownloadsTableWithTabsSkeleton = (): JSX.Element => (
  <div>
    <div className="sui-border-b-1">
      <SkeletonContent grow orientation="horizontal">
        <SkeletonBlock height={10} data-testid="skeleton-block" />
        <SkeletonBlock height={10} data-testid="skeleton-block" />
      </SkeletonContent>
    </div>
    {DownloadTableSkeleton()}
  </div>
);
